import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import Image from '../AppImage';

const MatchNotificationModal = ({ match, onClose, onSendMessage, onViewProfile }) => {
  if (!match) return null;

  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center p-4 bg-background/90 backdrop-blur-sm">
      <div className="bg-card rounded-xl shadow-warm-2xl border-2 border-primary/20 max-w-md w-full p-6 animate-scale-in">
        <div className="text-center mb-6">
          <div className="mx-auto w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mb-4 animate-bounce">
            <Icon name="Heart" size={40} color="#FFFFFF" />
          </div>
          <h2 className="text-2xl font-heading font-bold text-foreground mb-2">
            It's a Match! 🎉
          </h2>
          <p className="text-sm text-muted-foreground">
            You and {match?.displayName || 'this user'} liked each other
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="relative">
            <Image
              src={match?.image || '/assets/images/no_image.png'}
              alt={match?.imageAlt || 'Your profile'}
              className="w-24 h-24 rounded-full object-cover border-4 border-primary"
            />
          </div>
          <Icon name="Heart" size={32} color="var(--color-error)" />
          <div className="relative">
            <Image
              src={match?.matchedUserImage || '/assets/images/no_image.png'}
              alt={match?.matchedUserImageAlt || 'Matched user'}
              className="w-24 h-24 rounded-full object-cover border-4 border-primary"
            />
          </div>
        </div>

        <div className="space-y-3">
          <Button
            variant="default"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => {
              if (onSendMessage) {
                onSendMessage(match?.id);
              }
              onClose();
            }}
          >
            Send Message
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="Eye"
            iconPosition="left"
            onClick={() => {
              if (onViewProfile) {
                onViewProfile(match?.id);
              }
              onClose();
            }}
          >
            View Profile
          </Button>
          <Button
            variant="ghost"
            fullWidth
            onClick={onClose}
          >
            Keep Browsing
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MatchNotificationModal;
